import React, { Component } from 'react';

import './App.css';
import LandingPage from './LandingPage.jsx';

class App extends Component {
  render() {
    return <LandingPage />;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js